<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-fussion" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="container" *ngIf="showHtml">
    <div class="common loginformsection">				
        <div class="loginform">
            <div class="logodiv text-center">
                <a href="#" routerLink="/dashboard"><img src="assets/images/logo.png"></a>
            </div>
            <h6 class="formheading">Sign In</h6>
            <form (submit)="loginUser($event)">
                <div class="form-group">						  
                  <input type="email" class="form-control email inptdesgn" id="email" placeholder="Enter email" name="email" (keyup) ="emptyError()">
                  <span class="inputValidation">{{ emailError }}</span>
                </div>
                <div class="form-group mgbtmless">						  
                  <input type="password" class="form-control pwd inptdesgn" id="pwd" placeholder="Enter password" name="pswd" (keyup) ="emptyError()">
                  <span class="inputValidation">{{ passwordError }}</span>
                </div>
                <div class="form-group row">
                    <div class="col-md-6 col-sm-6 col-xs-6 smallfvty">
                        <label class="rmbrme">
                          <input type="checkbox" checked="checked" name="remember" class="chk_rmbrme" > Remember me
                        </label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 smallfvty text-right">
                        <label for="fgtpwd" class="fgtpwd "><a href="javascript:void(0)" routerLink="/forgot-password" class="clrblue" >Forgot Password</a></label>
                    </div>
                </div>
                <div class="form-group text-center">
                    <input type="submit" class="sgninbtn smallhndrd" name="sgninbtn" value="Sign in" >
                    <span class="inputValidation">{{confirmError}}</span>
                </div>
            </form>
            <div class=" privcttxt_div">
                <p class="privcttxt">By clicking Sign In, you agree to our <a href="javascript:void(0)" routerLink="/terms" target="_blank">Terms</a> and have read and acknowledge our <a href="javascript:void(0)" routerLink="/privacy" target="_blank">US Privacy Statement.</a></p>
            </div>
            <div class="signuptextdiv">
                <p class="privcttxt text-center">New to Nuflorist? <a href="javascript:void(0)" routerLink="/signup">Sign Up</a> </p>
            </div>
        </div>
    </div>
</div>